// extracted by mini-css-extract-plugin
export default {"table":"DetailsTable_table__nq11R","headerCell":"DetailsTable_headerCell__DC2ZP","cell":"DetailsTable_cell__6s-6G"};